// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"1557929ec1011c6dc092","655":"6d2c3d7a59d22235c34b"}[chunkId] + ".js";
};